export default "/images/Connexions360.svg?e778d5b85f16fe8964b1659d960ac14f";